module.exports = __webpack_public_path__ + "images/store_icon.svg";